import { ChevronDown } from 'lucide-react'
import Tag from './Tag'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/Select'
import {
  LANGUAGE_CODES,
  LanguageCode,
} from 'src/models/language'

const LanguageSelect = ({
  lang,
  color = 'white',
  backgroundColor = 'black',
  options = LANGUAGE_CODES,
  ...props
}: {
  lang: LanguageCode
  color?: string
  options?: LanguageCode[]
  backgroundColor?: string
} & React.ComponentPropsWithoutRef<typeof Select>) => (
  <Select value={lang} {...props}>
    <SelectTrigger className="w-[180px]">
      <Tag
        className="inline-flex items-center gap-1 py-1 pr-6 pl-4 text-[14px]"
        style={{
          color,
          backgroundColor,
        }}
      >
        <ChevronDown size={16} />
        <SelectValue />
      </Tag>
    </SelectTrigger>
    <SelectContent>
      {options.map((lang: LanguageCode) => {
        const [l, v] = lang.split('-')

        return (
          <SelectItem value={lang} key={lang}>
            {l} {v.toLocaleUpperCase()}
          </SelectItem>
        )
      })}
    </SelectContent>
  </Select>
)

export default LanguageSelect
